import PropTypes from 'prop-types';

import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';

import { getLeadImageUrl, isProfessionalTag } from '../../helpers/blogUtils';
import { formatPublicationDate } from '../../helpers/formatPublicationDate';

const BlogList = ({ items, isEditMode = false, loading = false }) => {
  const linkDisabled = isEditMode;

  return (
    <div className={`blog-container${loading ? ' loading' : ''}`}>
      {(items || []).map((item) => {
        const imageUrl = getLeadImageUrl(item, 'large');

        const itemContent = (
          <>
            <div
              className="blog-item-image"
              style={
                imageUrl ? { backgroundImage: `url("${imageUrl}")` } : undefined
              }
            />
            <div className="blog-item-data">
              <div className="blog-item-date">
                <span>{formatPublicationDate(item.effective)}</span>
              </div>
              <h3 className="blog-item-title csj-heading3">{item.title}</h3>
              {!isProfessionalTag(item) && item.description && (
                <div className="blog-item-description">
                  <span>{item.description}</span>
                </div>
              )}
            </div>
          </>
        );

        if (linkDisabled) {
          return (
            <div key={item['@id']} className="blog-item-container">
              {itemContent}
            </div>
          );
        }

        return (
          <ConditionalLink
            key={item['@id']}
            className="blog-item-container"
            item={item}
            condition
          >
            {itemContent}
          </ConditionalLink>
        );
      })}
    </div>
  );
};

BlogList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  isEditMode: PropTypes.bool,
  loading: PropTypes.bool,
};

BlogList.defaultProps = {
  items: [],
  isEditMode: false,
  loading: false,
};

export default BlogList;
